import { useTranslation } from '@web_opxp/features';
import React from 'react';
import { Continent, Country } from '../types';
import CountryButton from './CountryButton';

interface IContinentGroupProps {
  continent?: Continent;
  label?: string;
  countries: Country[];
  onSelect: (id: string) => void;
}

export const ContinentGroup: React.FC<IContinentGroupProps> = ({ continent, countries, onSelect, label }) => {
  const { t } = useTranslation();
  const title = label ? label : t(`TOU.continent.${continent}`) || continent;
  const list = countries.map((country: Country) => {
    return <CountryButton key={country.id} id={country.id} name={country.name} onSelect={onSelect} />;
  });
  return (
    <div className="continent-group">
      <h2 className="continent-title">{title}</h2>
      <div className="countries-list">{list}</div>
    </div>
  );
};

export default ContinentGroup;
